import { render, staticRenderFns } from "./GameDetailView.vue?vue&type=template&id=c3aef496&scoped=true"
import script from "./GameDetailView.vue?vue&type=script&lang=js"
export * from "./GameDetailView.vue?vue&type=script&lang=js"
import style0 from "./GameDetailView.vue?vue&type=style&index=0&id=c3aef496&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3aef496",
  null
  
)

export default component.exports